import { render, staticRenderFns } from "./CostDisplay.vue?vue&type=template&id=18997ed2&"
import script from "./CostDisplay.vue?vue&type=script&lang=js&"
export * from "./CostDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports